// removed by extract-text-webpack-plugin
module.exports = {"rankings-list":"rankings-list__2RX_l","ranking":"ranking__oVmSR","rank":"rank__2Y_Jy","total":"total__3zfx3","average-rating":"average-rating__9zj7l"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/Ranking/styles.scss
// module id = ./app/scripts/views/App/views/Ranking/styles.scss
// module chunks = 1